import { Tabs } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';
import getFormatMessage from '../../../locales/get-format-message';
import { SystemMenuId } from '../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';
import { GroupItemsComponent } from './group-items';
import { ObjectItemsComponent } from './object-items';

export const AdminPermissionManage = (props: { site?: string }) => {
  const { site } = props;
  const [currentTab, setCurrentTab] = useState<string>('DownLoad');
  const [listReload, setListReload] = useState<boolean>(false); // 用于group中批量完成更新object
  const supportSystem = location.pathname.endsWith('support-permission');
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: supportSystem
      ? SystemMenuId.SupportPermissionList
      : SystemMenuId.PermissionList,
  });
  const handleTabChange = (key: SetStateAction<string>) => {
    setCurrentTab(key);
  };

  return (
    <div>
      <Tabs activeKey={currentTab} onChange={handleTabChange}>
        <Tabs.TabPane tab={getFormatMessage('group_admin')} key="DownLoad">
          {/* Group内容 */}
          <GroupItemsComponent
            setListReload={setListReload}
            listReload={listReload}
            site={site}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab={getFormatMessage('object_admin')} key="Version">
          {/* object内容 */}
          <ObjectItemsComponent listReload={listReload} />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
